import { getBrowserLanguages } from '../lib/common';
import { IChannel } from '../types';

// Checks if the language selection modal should be shown.
export function isAwaitingLanguageSelection(
  channel: Pick<IChannel, 'public' | 'language' | 'respondent' | 'allowedLanguages'> | null | undefined,
  messages?: Array<{ createdBy?: string | null } | null> | null,
): boolean {
  if (!channel?.language || (channel.allowedLanguages?.length ?? 0) <= 1) {
    return false;
  }
  if (channel.respondent?.language) {
    return false;
  }
  if (localStorage.getItem('sessionLanguage')) {
    return false;
  }
  if (messages?.some((m) => m?.createdBy === 'RESPONDENT')) {
    return false;
  }

  const browserLanguage = getBrowserLanguages()[0];
  if (!channel.public && browserLanguage === channel.language.code) {
    return false;
  }

  return true;
}
